import  ApiCore from "./api_core"
import { DDESearchDemographics, DDEclientMergeData } from "./types"

export default class {
    programID: number
    readonly NATIONAL_ID_TYPE = 3

    constructor(programID: number) {
        this.programID = programID
    }

    findByNpid(npid: string) {
        return ApiCore.getJson('dde/patients/find_by_npid', {
            npid: npid, program_id: this.programID  
        })
    }

    findByDemographics(demographics: DDESearchDemographics) {
        return ApiCore.getJson(`dde/patients/find_by_name_and_gender`, {
            program_id: this.programID, ...demographics,
        })
    }

    findVoidedNpid(npid: string) {
        return ApiCore.getJson(`search/patients/by_identifier`, {
            voided: true,
            identifier: npid,
            type_id: this.NATIONAL_ID_TYPE
        })
    }

    getRemainingNpids() {
        return ApiCore.getJson('dde/patients/remaining_npids', {
            program_id: this.programID
        })
    }

    reassignNpid(docID: string, patientID: number) {
        return ApiCore.postJson('dde/patients/reassign_npid', {
            program_id: this.programID,
            patient_id: patientID,
            doc_id: docID
        })
    }

    createNpID(npid: string, patientID: number) {
        return ApiCore.postJson('patient_identifiers', {
            identifier: npid,
            patient_id: patientID,
            identifier_type: this.NATIONAL_ID_TYPE
        })
    }

    getLocalAndRemoteDiffs(patientID: number) {
        return ApiCore.getJson('dde/patients/diff', {
            patient_id: patientID,
            program_id: this.programID
        })
    }

    updateLocalDiffs(diffs: any, patientID: number) {
        return ApiCore.putJson(`people/${patientID}`, {
            program_id: this.programID, ...diffs
        })
    }

    refreshDemographics(patientID: number) {
        return ApiCore.getJson('dde/patients/refresh', {
            program_id: this.programID,
            patient_id: patientID
        })
    }

    importPatient(docID: string) {
        return ApiCore.getJson('dde/patients/import_by_doc_id', {
            program_id: this.programID,
            doc_id: docID
        })
    }

    mergePatients(primary: DDEclientMergeData, secondary: DDEclientMergeData) {
        return ApiCore.postJson('dde/patients/merge', {
            program_id: this.programID,
            primary,
            secondary
        })
    }

    checkPotentialDuplicates(demographics: Record<string, any>) {
        return ApiCore.getJson(`dde/patients/match_by_demographics`, {
            ...demographics, program_id: this.programID
        }) 
    }
}
